import { createFileRoute } from '@tanstack/react-router';
import { UploadAttachments } from '@/features/system/UploadAttachments';

export const Route = createFileRoute('/_app/upload-attachments')({ component: UploadAttachments });
